<template>
    <div class="container">
        <Logo />
        <div class="content-info">
            <div class="word">
                <div class="word-box" @click="playVideo()">
                    <img class="word-cover" :src="planVideo.cover_url" alt="">
                    <img class="word-play" src="@/assets/images/btn_start.png" alt="">
                </div>
                <van-overlay :show="isShow">
                    <div class="video-close" @click="closeVideo">
                        <img src="../assets/images/close.ss.png">
                    </div>
                    <div class="video-box">
                        <video oncontextmenu="return false" width="100%" height="100%" ref="videoPlayer" :src="planVideo.video_url" :poster="planVideo.cover_url" controls controlslist="nodownload" disablePictureInPicture></video>
                    </div>
                </van-overlay>
                <div class="small-title">人社厅函〔2021〕35号</div>
                <div class="word-title">
                    人力资源社会保障部办公厅<br/>
                    关于举办创业引领者专项活动暨<br/>
                    第三届马兰花全国创业培训讲师大赛的通知
                </div>
                <div class="line"></div>
                <div class="title">
                    各省、自治区、直辖市及新疆生产建设兵团人力资源和社会保障厅（局）：
                </div>
                <div class="paragraph">
                    为切实推动促“双创”、稳就业工作，深入实施职业技能提升行动创业培训“马兰花计划”，
                    充分发挥创业培训师资对创业培训指导的重要作用，不断提升创业培训和创业服务水平，持续引领促进创业带动就
                    业工作，经研究决定，2021年组织创业引领者专项活动暨第三届马兰花全国创业培训讲师大赛（以下简称专项活动）
                    。现将有关事项通知如下：
                </div>
                <div class="subhead">一、精心组织，强化统筹部署</div>
                <div class="paragraph">
                    专项活动是促“双创”、稳就业的重要举措，是职业技能提升行动创业培训“马兰花计划”的重要内容，
                    是巩固拓展脱贫攻坚成果和全面推进乡村振兴的重要抓手。各级人社部门要高度重视专项活动，
                    并将其纳入本地就业创业工作整体安排。要加强组织领导，结合本地实际和疫情防控要求，按照专项活动实施方案（附件1），
                    组建省级分赛组委会，制定省级分赛实施方案，落实经费等保障措施，统筹做好各项筹备和组织实施工作。
                </div>
                <div class="subhead">二、技术引领，加强能力建设</div>
                <div class="paragraph">
                    专项活动旨在普及创业培训标准，提升创业培训师资培训指导能力，加强基层创业培训服务队伍建设。
                    各地应组织本地创业培训师认真研究专项活动实施方案和大赛技术文件，科学设计，精心规划，
                    实现以活动促技术交流，以活动促能力提升，以活动促队伍建设。各地可以本次专项活动为契机，
                    配套组织创业培训师资提高研修、观摩研讨活动，补短板、固优势、促提升。有条件的地区也可同时组织管理人员、培训机构培训交流活动。
                </div>
                <div class="subhead"> 三、加大宣传，巩固活动品牌</div>
                <div class="paragraph">
                    各地要结合创业培训“马兰花计划”主题宣传及我部“双创周”安排等做好宣传动员，让各地创业工作主管部门、
                    创业培训师资、创业导师、创业培训服务机构及广大创业者了解和参与专项活动。要积极配合专项活动，
                    组织开展“讲师大赛启动仪式”“小马兰创业行”等线上宣传活动。要利用各类新媒体平台，广泛宣传推广各地大赛特色做法、
                    实际成效和典型人物，传播创业培训工作宝贵经验，展现创业培训师资精神风貌，激励全国创业培训服务一线工作者，
                    巩固专项活动及马兰花创业培训品牌，营造创业创新的良好氛围。
                </div>
                <div class="Linkman">
                    <p> 联 系 人：管颖、张薇</p>
                    <p> 联系电话：010-84661058、84661165</p>
                    <p> 传真电话：010-84661050</p>
                    <p> 电子邮箱：guanying@cettic.gov.cn</p>
                    <p>附件：1.专项活动实施方案</p>
                    <p style="margin-left:45px"> 2.专项活动组委会成员名单</p>
                    <p style="text-align:right">人力资源社会保障部办公厅</p>
                    <p style="text-align:right;margin-bottom:50px">2021年3月10日</p>
                    <p style="color:#999">（此件主动公开）</p>
                    <p>（联系单位：中国就业培训技术指导中心）</p>
                </div>
                <div class="dashad-line"></div>
                <div class="Attachment">
                    <div class="a-show">附件1：</div>
                    <div class="a-title">专项活动实施方案</div>
                    <div class="subhead">一、活动名称</div>
                    <div class="paragraph">
                        创业引领者专项活动暨第三届马兰花全国创业培训讲师大赛。
                    </div>
                    <div class="subhead"> 二、活动主题</div>
                    <div class="paragraph">
                        创业培训，创新引领。
                    </div>
                    <div class="subhead">  三、组织机构</div>
                    <div class="paragraph">
                        指导单位：就业司、职业能力司，负责活动整体指导；
                    </div>
                    <div class="paragraph">
                        主办单位：技术指导中心、就业促进会，负责活动整体策划及组织实施管理；
                    </div>
                    <div class="paragraph">
                        承办单位：就业促进会创业专委会、浙江省人力资源和社会保障厅、杭州市人力资源和社会保障局，负责活动具体实施。
                    </div>
                    <div class="paragraph">
                    专项活动成立组委会，负责统筹协调部署，由就业司、职业能力司、宣传中心、指导中心、就业促进会及承办单位有关同志担任相应职务。
                    </div>
                    <div class="subhead">  四、活动内容</div>
                    <div class="paragraph">
                    专项活动包括第三届马兰花全国创业培训讲师大赛（简称讲师大赛）和创业主题交流展示活动（简称交流展示）两项内容。
                    </div>
                    <div class="paragraph">
                    （一）讲师大赛
                    </div>
                    <div class="paragraph">
                        讲师大赛设三个赛道：“创办你的企业”（SYB）培训讲师综合能力赛、网络创业培训讲师综合能力赛和马兰花创业培训微课赛。综合能力赛主要考查讲师创业培训和创业指导的综合能力。
                        创业培训微课赛主要考查讲师教学设计和课程呈现能力。讲师可在“创办你的企业”（SYB）和网络创业培训综合能力赛中自行选择一个赛道参赛。参加综合能力赛的讲师也可参加创业培训微课赛。
                    </div>
                    <div class="paragraph">
                        （二）交流展示
                    </div>
                    <div class="paragraph">
                        通过专家点评、大师分享、成果发布及对话访谈等，交流先进理念，分享技术成果，对接优质资源，扩大项目影响。交流展示设创业服务技术研讨会分会场，交流工作经验，研讨工作思路。
                    </div>
                    <div class="subhead">五、参加人员</div>
                    <div class="paragraph">
                    （一）参赛选手
                    </div>
                    <div class="paragraph">
                    参赛选手为马兰花中国创业培训项目讲师，并满足以下条件：
                    </div>
                    <div class="paragraph">
                    1.自觉遵守国家法律法规和职业道德，诚实守信；
                    </div>
                    <div class="paragraph">
                    2.获得由创业培训主管部门核发的《创业培训（SIYB）讲师培训合格证书》或《网络创业培训讲师培训合格证书》。
                    </div>
                    <div class="paragraph">
                    3.严格执行创业培训标准和马兰花创业培训项目实施规程，承担创业培训学员班授课任务5次以上，满意度平均分不低于2.8分（满分3分）；开展学员培训后续服务30人次以上。
                    </div>
                    <div class="paragraph">
                    （二）大赛评委
                    </div>
                    <div class="paragraph">
                    大赛评委由各省级创业培训主管部门推荐的创业培训师及大赛活动组委会特邀专家构成。各省级创业培训主管部门推荐创业培训师评委应满足以下条件：
                    </div>
                    <div class="paragraph">
                        1.思想品德和业务能力突出，了解国家大政方针，精于先进培训技术，具有较强的创新能力和丰富的实战经验；
                    </div>
                    <div class="paragraph">
                        2.积极为国家或地方开展的相关课程开发、课题研究、活动组织、技术评审等工作提供技术支持，且各方满意度高；
                    </div>
                    <div class="paragraph">
                        3.取得中国就业培训技术指导中心核发的《创业培训师证书》，承担讲师培训班授课任务10次以上，期中授课平均分不低于4.8分（5分满分），开展讲师培训后续服务50人次以上。
                    </div>
                    <div class="paragraph">
                        （三）其他人员
                    </div>
                    <div class="paragraph">
                        专项活动还将邀请各省级创业培训与创业服务工作主管部门同志，有关部委、群团组织创业就业工作部门同志，乡村振兴重点帮扶地区代表，创业就业及中小企业发展服务领域专家等。
                    </div>
                    <div class="subhead">六、活动安排</div>
                    <div class="paragraph">
                        （一）2021年3月，印发通知，正式启动专项活动；
                    </div>
                    <div class="paragraph">
                        （二）2021年3月至8月，组织讲师大赛省级分赛。由各省级创业培训主管部门负责组织实施。各地按照疫情防控要求，
                        根据专项活动实施方案和讲师大赛技术文件（由中国就业培训技术指导中心另行印发）要求，设置竞赛内容、流程和规则，
                        确保公开、公平、公正，并推选出晋级全国总决赛的人选和作品；
                    </div>
                    <div class="paragraph">
                    （三）2021年9月，组织讲师大赛全国总决赛及交流展示。全国总决赛由专项活动组委会负责组织实施。晋级全国总决赛的“创办你的企业”（SYB
                    ）讲师和网络创业培训讲师进行现场综合能力赛，最终评出获奖选手；创业培训微课赛将对各省级分赛选送的竞赛作品进行选评，最终评出获奖作品。
                    </div>
                    <div class="subhead">七、奖项设置</div>
                    <div class="paragraph">
                        （一）个人奖项。“创办你的企业”（SYB）讲师综合能力赛设一等奖3人，二等奖7人，其余晋级全国总决赛选手获三等奖，前10名获“创办你的企业”（SYB）培训师资格；网络创业培训讲师综合能力赛设一等奖3人，
                        二等奖7人，其余晋级全国总决赛选手获三等奖，前10名获网络创业培训师资格；同时，通过“冠军争夺赛”产生讲师大赛总冠军1人。
                    </div>
                    <div class="paragraph">
                        （二）作品奖项。马兰花创业培训微课赛设一等奖3个，二等奖7个，三等奖10个，佳作奖10个。
                    </div>
                    <div class="paragraph">
                        （三）组织奖项。对积极组织省级分赛的省份颁发优秀组织奖；对积极承办和支持全国总决赛的单位
                    </div>
                    <div class="paragraph">
                        全国总决赛获奖选手、作品及单位将以专项活动组委会名义发文公布。
                    </div>
                </div>
                <div class="dashad-line"></div>
                <div class="Attachment">
                    <div class="a-show">附件2：</div>
                    <div class="a-title">专项活动组委会成员名单</div>
                    <div class="subhead"> 总顾问</div>
                    <div class="paragraph">
                        <span>张小建</span>   中国就业促进会会长
                    </div>
                    <div class="subhead"> 主  任</div>
                    <div class="paragraph">
                        <span>吴礼舵</span>    中国就业培训技术指导中心主任、党委书记
                    </div>
                    <div class="paragraph">
                        <span>莫<p style="display: inline-block;width:15px"></p>荣</span>    中国就业促进会副会长、中国劳动社会保障科学研究院副院长（正司级）
                    </div>
                    <div class="subhead">副主任</div>
                    <div class="paragraph">
                        <span>运东来</span>    人力资源社会保障部就业促进司副司长
                    </div>
                    <div class="paragraph">
                        <span>王晓君</span>    人力资源社会保障部职业能力建设司副司长、一级巡视员
                    </div>
                    <div class="paragraph">
                        <span>龚南香</span>    人力资源社会保障部宣传中心副主任
                    </div>
                    <div class="paragraph">
                        <span>袁<p style="display: inline-block;width:10px"></p> 芳</span>   中国就业培训技术指导中心副主任、一级巡视员
                    </div>
                    <div class="paragraph">
                        <span>陈<p style="display: inline-block;width:15px"></p>中</span>    浙江省人力资源和社会保障厅党组成员、副厅长
                    </div>
                    <div class="paragraph">
                        <span>叶茂东</span>    杭州市人力资源和社会保障局党组书记、局长、一级巡视员
                    </div>
                    <div class="subhead"> 成  员</div>
                    <div class="paragraph">
                        <span>娄权超</span>   人力资源社会保障部就业促进司创业指导处处长
                    </div>
                    <div class="paragraph">
                        <span>田<p style="display: inline-block;width:15px"></p>丰</span>   人力资源社会保障部职业能力建设司职业培训处处长
                    </div>
                    <div class="paragraph">
                        <span>牛<p style="display: inline-block;width:15px"></p>琳</span>   人力资源社会保障部宣传中心新闻处副处长
                    </div>
                    <div class="paragraph">
                        <span>蔡<p style="display: inline-block;width:15px"></p>兵</span>   中国就业培训技术指导中心职业培训服务处处长
                    </div>
                    <div class="paragraph">
                        <span>李燕萍</span>   中国就业促进会秘书长
                    </div>
                    <div class="paragraph">
                        <span>陈军利</span>   浙江省人力资源和社会保障厅就业管理中心副主任
                    </div>
                    <div class="paragraph">
                        <span>方海洋</span>   杭州市人力资源和社会保障局党组成员、副局长
                    </div>
                    <div class="paragraph">
                        专项活动组委会设若干工作组：综合协调组负责日常组织实施工作；竞赛组负责赛事组织；
                        活动组负责交流展示的策划及组织；专家组负责大赛命题、技术文件及评分标准制定；
                        仲裁组负责现场监督及争议问题处理；保障服务组负责疫情防控、接待安排等；
                        宣传组负责媒体报道、线上推动、宣传片制作。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getVideo } from "../api/index"
import Logo from "../components/Logo"
export default {
    name: 'introduce',
    components: {
        Logo,
    },
    data(){
        return {
            isShow:false,
            planVideo: {}
        }
    },
    created() {
        this.getVideo()
    },
    methods: {
        getVideo(){
            getVideo().then(res=>{
                if(res.code == 200){
                    let videoData = res.data.list
                    this.planVideo = videoData.filter(pilot => pilot.type === 3)[0]
                }
            }).catch({})
        },
        playVideo() {
            this.isShow = true
        },
        closeVideo() {
            this.isShow = false
            this.$refs.videoPlayer.pause();
        },
    }
}
</script>

<style lang="scss" scoped>
    .head-img{
        display: block;
        width: 100%;
    }
    .content-info{
        width: 100%;
        background: #F4F6FD;
        .address{
            width: 1200px;
            margin:0 auto;
            padding: 32px 0 42px 0;
            font-size: 16px;
            overflow: hidden;
            line-height: 16px;
            color: #333;
            .address-icon{
                width: 12px;
                height: 16px;
                float: left;
                margin-right: 4px;
            }
            span{
                float: left;
                font-size: 16px;
            }
        }
        .word{
            margin: 0 auto;
            background: #fff;
            min-height: 300px;
            box-sizing: border-box;
            padding: 40px;
            color: #666;
            .word-box{
                position: relative;
                margin-bottom: 32px;
                .word-cover{
                    width: 100%;
                    height: 395px;
                }
                .word-play{
                    width: 120px;
                    height: 120px;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-left: -60px;
                    margin-top: -60px;
                }
            }
            .small-title{
                font-size: 26px;
                color: #333;
                line-height: 26px;
                margin-bottom: 48px;
                text-align: center;
            }
            .word-title{
                font-size: 28px;
                font-weight: 500;
                color: #333333;
                line-height: 42px;
                text-align: center;
                margin-bottom: 40px;
            }
            .line{
                width: 100%;
                height: 2px;
                background: #2F54EB;
                opacity: 0.31;
            }
            .title{
                font-size: 32px;
                margin-top: 40px;
                margin-bottom: 40px;
            }
            .paragraph{
                font-size: 32px;
                line-height: 55px;
                text-indent:65px;
                margin-bottom: 25px;
                span{
                    margin-right: 15px;
                }
            }
            .subhead{
                font-weight: bold;
                text-indent:30px;
                color:#333;
                margin-bottom: 25px;
            }
            .Linkman{
                p{
                    margin-bottom: 30px;
                }
            }
            .dashad-line{
                width: 100%;
                height: 1px;
                opacity: 0.31;
                border-bottom: 2px dashed #2F54EB;
                margin: 40px 0;
            }
            .a-show{
                color: #2F54EB;
            }
            .a-title{
                text-align: center;
                font-weight: bold;
                font-size: 28px;
                margin: 40px 0;
                color: #333;
            }
        }
    }
   
   .video-close{
        position: absolute;
        width: 84px;
        height: 84px;
        right: 0;
        top: 0;
        margin: auto;
        img{
            display: block;
            width: 48px;
            height: 48px;
            margin-top: 18px;
            margin-left: 18px;
        }
    }
    .video-box{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 84px;
        margin: auto;
    }
   
    
</style> 
